import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';

import { HomeDashboardComponent } from './components/home-dashboard.component';
import { homeRoutes } from './routes.config';

@NgModule({
  entryComponents: [],
  declarations: [HomeDashboardComponent],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature('home', {}),
    EffectsModule.forFeature([]),
    RouterModule.forChild(homeRoutes)
  ],
  exports: [],
  providers: []
})
export class HomeModule {}



// WEBPACK FOOTER //
// ./src/app/home/home.module.ts